import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import PropTypes from 'prop-types';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React from 'react';

import { setTestId } from '../util/testUtils';
import { updatePaymentMethod } from '../actions/payment-actions';
import paymentTypes from '../constants/payment-type-constants';

function PaymentMethodControl(props) {
  const { creditCard, paymentType, handleUpdatePaymentMethod } = props;

  const handlePaymentType = (event) => {
    // call action paymentType: event.target.value
    handleUpdatePaymentMethod(event.target.value);
  };

  if (!creditCard.ccDisplay) {
    // If the user has no credit card, there's no need to present a choice
    return null;
  }

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">Payment Method</FormLabel>
      <RadioGroup
        name="paymentMethod"
        onChange={handlePaymentType}
        value={paymentType}
      >
        {creditCard.ccDisplay && (
          <FormControlLabel
            control={
              <Radio color="primary" {...setTestId('paymentMethodExisting')} />
            }
            label="Card on file"
            value={paymentTypes.EXISTING}
          />
        )}
        <FormControlLabel
          control={<Radio color="primary" {...setTestId('paymentMethodNew')} />}
          label="Pay with a different card"
          value={paymentTypes.NEW}
        />
        {/* <FormControlLabel
          value={paymentTypes.ACH}
          control={<Radio color="primary" />}
          label="Pay with ACH"
        /> */}
      </RadioGroup>
    </FormControl>
  );
}

function mapStateToProps(state) {
  return {
    creditCard: state.invoice.creditCard,
    paymentType: state.payment.paymentType,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handleUpdatePaymentMethod: updatePaymentMethod,
    },
    dispatch
  );
}
PaymentMethodControl.propTypes = {
  creditCard: PropTypes.shape({
    ccDisplay: PropTypes.string,
  }).isRequired,
  paymentType: PropTypes.string.isRequired,
  handleUpdatePaymentMethod: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentMethodControl);
